import Vue from 'vue'
import VueRouter from 'vue-router'
import Views from '../views'
// import Home from '../views/Home'
// import Unauth from '../views/unauth'
import store from '../store'

Vue.use(VueRouter)

// const QuestionBank = [
// ]

let routes = {
  auth: [
    { path: '/dashboard', name: 'dashboard', component: Views.Dashboard },
    { path: '/program', name: 'list-program', component: Views.Program.List },
    { path: '/program/users/:id', name: 'list-user', component: Views.User.list },
    { path: '/program/tambah-program', name: 'add-program', component: Views.Program.Form },
    { path: '/program/edit/:id', name: 'edit-program', component: Views.Program.Detail },
    { path: '/update-password', name: 'update-password', component: Views.Auth.UpdatePassword },

    { path: '/program/:id', name: 'program-detail', component: Views.Programs.Detail },
    
    // import
    { path: '/import', name: 'import-data', component: Views.Import.FormImport },
    { path: '/import-feedback', name: 'import-data-feedback', component: Views.Import.FormImportFeedback },
    { path: '/import-history', name: 'import-history', component: Views.Import.HistoryImport },
    { path: '/import-history-tpm', name: 'import-history-tpm', component: Views.Import.HistoryImportTPM },

    //certificate
    { path: '/certificate-participant/:id', name: 'certificate-participant', component: Views.Certif.CertifPart },
    { path: '/certificate-graduation/:id', name: 'certificate-graduation', component: Views.Certif.CertifGrad },
  
    //discussion private
    { path: '/discussion/private', name: 'presensi', component: Views.Discusstion.Private.List },
    { path: '/discussion/private/program/:id', name: 'discussion-private-program-detail', component: Views.Discusstion.Private.ListDiscussion },
    { path: '/discussion/private/program/:program/:topic/:id', name: 'discussion-private-list', component: Views.Discusstion.Private.ListDiscussion },
    
    //discussion public
    { path: '/discussion/public', name: 'presensi', component: Views.Discusstion.Public.List },
    { path: '/discussion/public/program/:id', name: 'discussion-public-program-detail', component: Views.Discusstion.Public.Detail },
    { path: '/discussion/public/program/:program/:topic/:id/:act_name', name: 'discussion-public-list', component: Views.Discusstion.Public.ListDiscussion },

  ],
  guest: [
    { path: '/', name: 'login', component: Views.Auth.Login },
    { path: '/forgot-password', name: 'forgot-password', component: Views.Auth.ForgotPassword },
    { path: '/password-reset', name: 'password-reset', component: Views.Auth.PasswordReset },
    { path: '/password-changed', name: 'password-changed', component: Views.Auth.PasswordChanged },
  ],
  default: [
    { path: '*', name: '404 Not Found', component: Views.Errors.NotFound },
  ]
}

routes.auth.forEach(route => { route.meta = { auth: true } });
routes.guest.forEach(route => { route.meta = { guest: true } });
routes = [
  ...routes.auth,
  ...routes.guest,
  ...routes.default,
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path == '/' && store.getters.isLoggedIn) {
    return next('/dashboard')
  }
  if (to.meta.auth && !store.getters.isLoggedIn) {
    sessionStorage.setItem('ytc_redirect', location.pathname)
    return next('/')
  }
  if (to.meta.guest && store.getters.isLoggedIn) {
    return next('/dashboard')
  }
  return next()
})

export default router
